import { Table, createStyles } from '@mantine/core';
import React from 'react';

import { textStyles } from '~/domains/design-system/Text';
import type { ScoreBreakdown } from '~/domains/games/interfaces/player-detail.interface';

const useStyles = createStyles((theme) => ({
  container: {
    background: theme.white,
  },
  container2: {
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._16}px`,
    border: `1px solid ${theme.colors.gray2[0]}`,
    borderRadius: theme.radius.sm,
  },
  table: {
    '& tbody tr td': {
      ...textStyles['body-small'],
      color: theme.colors.gray2[3],
      paddingLeft: 0,
      paddingRight: 0,
      borderTopColor: theme.colors.gray2[0],

      '&.score': {
        ...textStyles['subhead-x-small'],
        color: theme.colors.gray2[6],
        textAlign: 'right',
      },
    },
  },
}));

type GamecenterPlayerDetailScoreBreakdownProps = {
  tableData: ScoreBreakdown[];
};

function GamecenterPlayerDetailScoreBreakdown({
  tableData,
}: GamecenterPlayerDetailScoreBreakdownProps) {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.container2}>
        <Table className={classes.table}>
          <tbody>
            {tableData.map(({ label, score }) => (
              <tr key={label}>
                <td>{label}</td>
                <td className="score">{score}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default GamecenterPlayerDetailScoreBreakdown;
